import { Link } from "gatsby";
import slidesTAG from "../../../../src/collections/events/2021/kubecon-china-2021/cncf-tag-network-and-service-mesh-working-group-kubecon-china-2021-lee-calcote-ken-owens.pdf";
import slidesAdopt from "../../../../src/collections/events/2021/kubecon-china-2021/solving-the-service-mesh-adopters-dilemma-anita-ihuman-kubecon-china-2021.pdf";
import * as React from 'react';
export default {
  Link,
  slidesTAG,
  slidesAdopt,
  React
};